/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */

export const getSplittedMatrix = (element: any) => {
  const matrixArraySplited: any = [];

  const { numberOfRowsToSplit } = element;
  const countSplitRows = Math.ceil(element?.rows?.length / numberOfRowsToSplit);

  for (let count = 0; count < countSplitRows; count += 1) {
    if (count !== countSplitRows - 1) {
      const newMatrixesArray1: any = {
        ...element,
        rows: element.rows.slice(
          count * numberOfRowsToSplit,
          count * numberOfRowsToSplit + numberOfRowsToSplit,
        ),
      };

      matrixArraySplited.push(newMatrixesArray1);
    } else {
      const lastGroup = parseInt(
        (
          (element.rows.length / numberOfRowsToSplit -
            Math.floor(element.rows.length / numberOfRowsToSplit)) *
          10
        ).toString(),
        10,
      );

      const newMatrixesArray2 = {
        ...element,
        rows: element.rows.splice(
          count * numberOfRowsToSplit,
          count * numberOfRowsToSplit + lastGroup,
        ),
      };

      matrixArraySplited.push(newMatrixesArray2);
    }
  }
  return matrixArraySplited;
};
